import { render, staticRenderFns } from "./doubleSwitch.vue?vue&type=template&id=0fea1c90"
import script from "./doubleSwitch.vue?vue&type=script&lang=js"
export * from "./doubleSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports